export default "__VITE_ASSET__SjXnPrbC__"